module.exports = __webpack_public_path__ + "img/II-21.ed0ce802.svg";